import { createSelector } from "reselect";

import Store from "../../../../../redux/store";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { Nullable } from "../../../../../types/common";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";

import { getCampaignBriefState } from "../../../store/campaign-brief.store";
import { CampaignBriefState } from "../../../types/campaign-brief-state/campaign-brief-state.interface";

import { CampaignBriefProductsState } from "../types/campaign-brief-products.interface";

import * as actions from "./campaign-brief-products.actions";

export const getCampaignBriefProductsState = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.productsState
);

export const isLoading = createSelector(
  getCampaignBriefProductsState,
  (state: CampaignBriefProductsState) => state.loading
);

export const getErrors = createSelector(
  getCampaignBriefProductsState,
  (state: CampaignBriefProductsState) => state.errors
);

export const getProducts = createSelector(
  getCampaignBriefProductsState,
  (state: CampaignBriefProductsState) => state.products
);

export const hasErrors = createSelector(getErrors, (errors: Nullable<IError>) => !!errors);

export function fetchProducts(CampaignBriefId: number) {
  Store.dispatch(actions.fetchProducts(CampaignBriefId));
}

export function updateProducts(form: BriefProductForm[], CampaignBriefId: number) {
  Store.dispatch(actions.updateProducts(form, CampaignBriefId));
}

export function addProduct(product: number, CampaignBriefId: number) {
  Store.dispatch(actions.addProduct(product, CampaignBriefId));
}
